export namespace Listrak {

    export interface InitOptions {
        id: string
    }

    export class ListrakPlugin {
        private readonly id: string // JBG_LISTRAK_ID

        constructor(options: Listrak.InitOptions) {
            this.id = options.id
        }

        // Call setup once in layouts/default.vue
        public setup() {
            if (this.id) {
                const listrakScript = document.createElement('script')
                listrakScript.setAttribute('src', `https://cdn.listrakbi.com/scripts/script.js?m=${this.id}&v=1`)
                document.head.appendChild(listrakScript)
            }
        }

        // Wrapper for Listrak's async listener in order to execute custom code
        // Defining this as a helper function means we only have to write this ugly copypasta once
        // See Listrak docs: https://help.listrak.com/en/articles/4820523-javascript-website-integration-installation
        public ltk(customHandler: (_ltk: any) => any) {
            (((d: () => void): void => {
                if (typeof _ltk === 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('ltkAsyncListener', () => {
                            // eslint-disable-next-line no-underscore-dangle,camelcase
                            _ltk_util.ready(d)
                        })
                    } else {
                        const e = document.documentElement
                        e.ltkAsyncProperty = 0
                        e.attachEvent('onpropertychange', (e) => {
                            // eslint-disable-next-line eqeqeq
                            if (e.propertyName == 'ltkAsyncProperty') {
                                // eslint-disable-next-line no-underscore-dangle,camelcase
                                _ltk_util.ready(d)
                            }
                        })
                    }
                } else {
                    // eslint-disable-next-line no-underscore-dangle,camelcase
                    _ltk_util.ready(d)
                }
            })((): void => {
                /** ******** Begin Custom Code ********* */
                customHandler(_ltk)
                /** ******** End Custom Code *********** */
            }))
        }
    }

    export function install(key: string) {
        return new ListrakPlugin({ id: key })
    }
}


declare module '@vue/runtime-core' {
}
